module.exports = __webpack_public_path__ + "static/media/close-icn.321c232d.svg";